import { map } from "nanostores";

export type MapStore = {initialized: boolean}

export const $map = map<MapStore>({
  initialized: false,
});

export function setInitialized(value: boolean) {
  const store = $map.get();
  $map.set({ ...store, initialized: value });
}
